module.exports = vendor_fab326c1220fa9434a26;


//////////////////
// WEBPACK FOOTER
// external "vendor_fab326c1220fa9434a26"
// module id = 2
// module chunks = 6